import * as AnnouncementActions from '../actions/announcement.actions';

const initState = {
  data: null,
  loading: false,
  message: null,
};

const announcementReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AnnouncementActions.ANNOUNCEMENT_GET_ACTIVE:
      return { ...state, loading: true, message: null };
    case AnnouncementActions.ANNOUNCEMENT_GET_ACTIVE_SUCCESS:
      return { ...state, loading: false, data: payload };
    case AnnouncementActions.ANNOUNCEMENT_GET_ACTIVE_FAIL:
      return { ...state, loading: false, data: null, message: payload?.message };
    default:
      return state;
  }
};

export default announcementReducer;
